// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hr-text[data-v-5329c77e]{border:0;height:1.5em;line-height:1em;opacity:.5;outline:0;position:relative;text-align:center}.hr-text[data-v-5329c77e]:before{background:#b1b6b9;content:\"\";height:1px;left:0;position:absolute;top:50%;width:100%}.hr-text[data-v-5329c77e]:after{background-color:#fff;color:#b1b6b9;content:attr(data-content);display:inline-block;line-height:1.5em;padding:0 .5em;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
